import { Modal, ModalProps } from 'react-native'

import { DEVICE_HEIGHT, DEVICE_WIDTH } from '@zet/utils/Constants'

import { CloseButton } from '../closeButton'

interface PopupFullScreenType extends ModalProps {
  children: React.ReactNode
  handlePopupClose: () => void
}
export const PopupFullScreen = ({
  children,
  handlePopupClose,
  ...props
}: PopupFullScreenType) => {
  return (
    <Modal style={{ height: DEVICE_HEIGHT, width: DEVICE_WIDTH }} {...props}>
      <CloseButton
        className="absolute left-3 top-4 z-10 rounded bg-[#1C273714] px-1 py-1"
        handleClose={handlePopupClose}
      />
      <>{children}</>
    </Modal>
  )
}
